import {FETCHED_BALANCE} from '../../types';
import {web3} from '../../../config'

export function getETHBalanceDispatch(){
  return function(dispatch,getState){
    getETHBalance(dispatch,getState())
  }
}

export async function getETHBalance(dispatch,state) {
  for(let address of Object.keys(state.passport.wallet.eth)){
    let result = await web3.eth.getBalance(address)
    dispatch({
      type: FETCHED_BALANCE,
      payload: {balance:web3.utils.fromWei(result),asset:'eth',address}
    });
  }
}
